import React from 'react';

const Cricket = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12549_39775)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.5457 6.23681C17.2665 5.83895 16.8319 5.29155 16.1879 4.64754C15.5439 4.00353 14.9965 3.56896 14.5987 3.28982L5.39985 12.4886C5.67899 12.8865 6.11357 13.4339 6.75757 14.0779C7.40158 14.7219 7.94898 15.1565 8.34684 15.4356L17.5457 6.23681ZM14.899 1.99014C14.6082 1.81036 14.2446 1.87573 14.0028 2.11751L4.22755 11.8927C3.98577 12.1345 3.92039 12.4981 4.10018 12.789C4.34126 13.179 4.76183 13.7781 5.43833 14.5098L2.48097 17.4671L3.36506 18.3512L6.32229 15.394C7.05553 16.0723 7.65588 16.4938 8.04651 16.7353C8.33736 16.9151 8.70095 16.8497 8.94273 16.6079L18.718 6.83269C18.9597 6.59091 19.0251 6.22733 18.8453 5.93648C18.5562 5.46879 18.0091 4.7005 17.072 3.76344C16.135 2.82639 15.3667 2.27923 14.899 1.99014ZM4.57832 3.12611C3.77271 3.12611 3.11964 3.77918 3.11964 4.58479C3.11964 5.3904 3.77271 6.04348 4.57832 6.04348C5.38393 6.04348 6.03701 5.3904 6.03701 4.58479C6.03701 3.77918 5.38393 3.12611 4.57832 3.12611ZM1.86934 4.58479C1.86934 3.08866 3.08219 1.87581 4.57832 1.87581C6.07445 1.87581 7.28731 3.08866 7.28731 4.58479C7.28731 6.08093 6.07445 7.29378 4.57832 7.29378C3.08219 7.29378 1.86934 6.08093 1.86934 4.58479Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12549_39775" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { Cricket };
//# sourceMappingURL=Cricket.js.map
